import { useNavigate } from "react-router-dom";
import { matchPath, useLocation } from "react-router-dom";
import { Dropdown } from "antd";
import { MoreOutlined, MenuOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Drawer from "../../../ReusableComponent/Drawer";
import datacodelogo from "../../../../assets/images/Datacode_white_logo.png";

const navItems = [
  { label: "Dashboard", link: "/quiz" },
  { label: "PlacementPrep", link: "/placement" },
  { label: "ExamPrep", link: "/exam" },
  { label: "Quizzes", link: "/quizzes" },
  { label: "Certificates", link: "/certificate" },
  // { label: "Tournaments", link: "/tournaments" },
];

const QuizStudioHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const currentUser = JSON.parse(localStorage.getItem("userDetails"));
  const hideHeaderRoute = matchPath("/login", location.pathname);

  useEffect(() => { }, [currentUser]);

  const handleLogout = () => {
    localStorage.clear();
    // document.cookie =
    //   "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "access_token=; path=/; domain=.datacode.in; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    navigate("/");
  };

  const handleLogIn = () => {
    navigate("/login");
  };

  // Define menu items using the `items` prop
  const menuItems = [
    {
      key: "1",
      label: "LogOut",
      onClick: handleLogout,
    },
    // Add more items if needed
  ];

  return (
    <div className="bg-dark-custom header">
      <nav className="navbar navbar-expand-lg row mx-0 d-flex justify-content-evenly p-3">
        <div className="col-12  d-flex justify-content-between align-items-center">
          <div className="col-md-4 d-flex justify-content-start align-items-center ps-lg-3">
            {/* Hamburger - visible only on mobile */}
            <MenuOutlined
              className="text-white fs-3 me-3 d-lg-none"
              onClick={() => setDrawerOpen(true)}
              style={{ cursor: "pointer" }}
            />
            <Link to="/" className="text-decoration-none text-white">
              <img src={datacodelogo} alt="datacodelogo" className="logo" />
            </Link>
            <span
              className="text-white fw-bold quiz-title"
              style={{ fontSize: "20px" }}
            >
              Quiz Studio
            </span>
          </div>
          <div className="col-md-6 d-flex justify-content-evenly">
            {/* Nav Links */}
            <ul className="navbar-nav mx-auto d-none d-lg-flex">
              {navItems.map((item, idx) =>
                <li key={idx} className="nav-item">
                  <Link
                    className={`nav-link transition-smooth ${location.pathname === item.link ? "active" : ""
                      }`}
                    to={item.link}
                  >
                    {item.label}
                  </Link>
                </li>
              )}
            </ul>
          </div>
          <div className="col-md-2 col-2 d-flex justify-content-end align-items-center pe-lg-3">
            {currentUser && (
              <>
                <span className="d-none d-md-block fw-bold">
                  {currentUser?.firstName}
                </span>
                <img
                  src={currentUser?.imgUrl ? currentUser?.imgUrl : `https://cdn-icons-png.flaticon.com/512/7381/7381253.png`}
                  className="border-none border-dark rounded-5 mx-3 d-md-block d-none"
                  alt="User"
                  onError={(e) => {
                    e.target.onerror = null; // prevent infinite loop
                    e.target.src = "https://cdn-icons-png.flaticon.com/512/7381/7381253.png";
                  }}
                  height={40}
                  width={40}
                />
                {/* <span className="d-none d-md-block fw-bold">
                  <Dropdown
                    menu={{
                      items: menuItems,
                      style: { backgroundColor: "#fff", color: "#000" },
                    }}
                    trigger={["click"]}
                  >
                    <MoreOutlined className="menu-icon" />
                  </Dropdown>
                </span> */}
                <button
                  className="btn d-flex align-items-center text-white justify-content-between d-md-block d-none custom-button"
                  style={{ cursor: "pointer" }}
                  onClick={handleLogout}
                >
                  Logout
                </button>
              </>
            )}

            {!currentUser && !hideHeaderRoute && (
              <button
                className="btn d-flex align-items-center  text-white justify-content-between  onClick={handleLogIn} custom-button"
                style={{ cursor: "pointer" }}
                onClick={handleLogIn}
              >
                LogIn
              </button>
            )}
          </div>
        </div>
      </nav>
      {/* ====== Mobile Drawer ====== */}
      <Drawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        placement="left"
        closable={true}
        title="Menu"
        width={280}
        className="text-white"
        style={{
          background:
            "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
        }}
      >
        <ul className="list-unstyled ">
          {navItems.map((item, idx) => (
            <li key={idx} className="mb-3">
              {item.dropdown ? (
                <>
                  <strong className="text-white">{item.label}</strong>
                  <ul className="list-unstyled ms-3 mt-2">
                    {item.dropdown.map((drop, i) => (
                      <li key={i}>
                        <Link
                          className="text-decoration-none text-white"
                          to={drop.link}
                          onClick={() => setDrawerOpen(false)}
                        >
                          {drop.icon} {drop.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </>
              ) : (
                <Link
                  className="text-decoration-none text-white fw-semibold"
                  to={item.link}
                  onClick={() => setDrawerOpen(false)}
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ul>

        <hr />
        {currentUser ? (
          <button
            className="btn btn-primary w-100 fw-semibold"
            onClick={() => {
              setDrawerOpen(false);
              handleLogout();
            }}
          >
            Log Out
          </button>
        ) : (
          <button
            className="btn btn-primary w-100 fw-semibold"
            onClick={() => {
              setDrawerOpen(false);
              handleLogIn();
            }}
          >
            Log In
          </button>
        )}
      </Drawer>
    </div>
  );
};

export default QuizStudioHeader;
